import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// Check if browser supports required features for Firebase Messaging
function isFirebaseMessagingSupported() {
    return 'serviceWorker' in navigator && 
           'PushManager' in window && 
           !isUnsupportedBrowser();
}

// Detect browsers that don't support Firebase Messaging properly
function isUnsupportedBrowser() {
    const ua = navigator.userAgent || '';
    return ua.includes('Instagram') || 
           ua.includes('FBAN') || 
           ua.includes('FBAV') ||
           ua.includes('Line/') ||
           ua.includes('Twitter');
}

// Only initialize Firebase in supported browsers
if (isFirebaseMessagingSupported()) {
    // Register Service Worker first
    navigator.serviceWorker
        .register('/firebase-messaging-sw.js')
        .then(registration => {
            console.log('Service Worker registered with scope:', registration.scope);
            
            // Dynamically import and initialize Firebase only after SW registration
            import('./firebase.js')
                .then(firebaseModule => {
                    console.log('Firebase Messaging initialized successfully');
                    // You can now use firebaseModule.messaging, firebaseModule.getToken, etc.
                })
                .catch(error => {
                    console.error('Failed to initialize Firebase:', error);
                });
        })
        .catch(err => {
            console.error('Service Worker registration failed:', err);
        });
} else {
    console.log('Firebase Messaging not supported in this browser - continuing without push notifications');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();